import { render } from "./PuzzleGradePractice.vue?vue&type=template&id=6785a1a5"
import script from "./PuzzleGradePractice.vue?vue&type=script&lang=js"
export * from "./PuzzleGradePractice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__